<template>
    <!-- 日历组件-日 -->
    <div class="calendar-day">
        <div class="flex">
            <div>
                <div v-for="(item, index) in timeList" :key="index" class="mr-20">
                    <p class="title" :style="index === timeList.length - 1 ? 'margin: 0' : ''">{{item.time}}</p>
                </div>
            </div>
            <div style="flex: 1">
                <div class="mt-10" style="position: relative;">
                    <div v-for="(item, index) in timeList" :key="index" class="line" :style="index === timeList.length - 1 ? 'display: none' : ''">
                        <div v-for="(itm, inx) in datalist" :key="inx">
                            <el-popover placement="right" width="300" trigger="hover" popper-class="calendar-popover">
                                <div class="content">
                                    <div class="flex ai-c">
                                        <p class="title">{{itm.classname}}</p>
                                    </div>
                                    <p class="text">{{`${itm.perioddate} (${itm.week}) ${itm.starttime}~${itm.endtime}` }}</p>
                                    <p class="text">课程:{{itm.classcoursename}}</p>
                                    <p class="text">老师:{{itm.teachername ? itm.teachername : '暂无老师'}}</p>
                                    <p class="text">教室:{{itm.periodplace ? itm.periodplace : '暂无教室'}}</p>
                                    <div class="flex jc-sb ai-c btn">
                                        <span @click="openClassDetail(itm)">详情</span>
                                        <span v-if="itm.status === 10 && nowDate < getTimeStr(dayTime+' '+itm.starttime)" @click="openClassEdit(itm)">编辑</span>
                                        <span v-if="itm.status === 10 && nowDate < getTimeStr(dayTime+' '+itm.starttime) || itm.status == 30" @click="del(itm)">删除</span>
                                    </div>
                                </div>
                                <div class="box text-ellipse" slot="reference" v-show="(handlerSetTime(itm, item,  index) || handlerSetTime1(itm, item,  index)) && item.num < 1
                                ">
                                    {{itm.classname}}
                                </div>
                            </el-popover>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
      timeList: [
        {
          time: '00:00',
          num: 0
        },
        {
          time: '08:00',
          num: 0
        },
        {
          time: '09:00',
          num: 0
        },
        {
          time: '10:00',
          num: 0
        },
        {
          time: '11:00',
          num: 0
        },
        {
          time: '12:00',
          num: 0
        },
        {
          time: '13:00',
          num: 0
        },
        {
          time: '14:00',
          num: 0
        },
        {
          time: '15:00',
          num: 0
        },
        {
          time: '16:00',
          num: 0
        },
        {
          time: '17:00',
          num: 0
        },
        {
          time: '18:00',
          num: 0
        },
        {
          time: '19:00',
          num: 0
        },
        {
          time: '20:00',
          num: 0
        },
        {
          time: '21:00',
          num: 0
        },
        {
          time: '22:00',
          num: 0
        },
        {
          time: '24:00',
          num: 0
        }
      ],
      nowDate: new Date().getTime()
    }
  },
  props: {
    datalist: {
      type: Array,
      required: true,
      default: []
    },
    dayTime: {
      type: String
    }
  },
  methods: {
    getTimeStr(time) {
      return new Date(time).getTime()
    },
    handlerSetTime(item, res, residx) {
      console.log(item, res, residx)
      let flag = false
      let nowTime = this.getTimeStr(item.perioddate + ' ' + res.time)
      let nowTime1 = this.getTimeStr(item.perioddate + ' ' + item.starttime)
      // console.log(nowTime, nowTime1)
      if (nowTime <= nowTime1) {
        flag = true
      }
      let flag1 = false
      let nowTimeT = this.getTimeStr(item.perioddate + ' ' + item.starttime)
      let nowTime1T = this.getTimeStr(
        item.perioddate +
          ' ' +
          (residx < this.timeList.length - 1
            ? this.timeList[residx + 1].time
            : this.timeList[residx].time)
      )
      if (nowTimeT < nowTime1T) {
        flag1 = true
      }
      if (flag && flag1) {
        console.log(item, 'item')
        console.log(res.num, res, 'res.numres.num')
        //  res.num = res.num + 1
        // residx < this.timeList.length - 1 ? this.timeList[residx + 1].num ++ : this.timeList[residx].num ++
        return true
      }
    },
    handlerSetTime1(item, res, residx) {
      let flag = false
      let nowTime = this.getTimeStr(
        item.perioddate + ' ' + this.timeList[residx].time
      )
      let nowTime1 = this.getTimeStr(item.perioddate + ' ' + item.endtime)
      // console.log(nowTime, nowTime1)
      if (nowTime <= nowTime1) {
        flag = true
      }
      let flag1 = false
      let nowTimeT = this.getTimeStr(item.perioddate + ' ' + item.starttime)
      let nowTime1T = this.getTimeStr(
        item.perioddate + ' ' + this.timeList[residx].time
      )
      if (nowTimeT <= nowTime1T) {
        flag1 = true
      }
      if (flag && flag1) {
        // this.timeList[residx].num = this.timeList[residx].num + 1
        // console.log(this.timeList[residx].num,';this.timeList[residx].num')
        console.log(item, 'item')
        return true
      }
    },
    //  计算时间差
    compareTime(time1, time2) {
      let arr1 = time1.split(':')
      let arr2 = time2.split(':')
      let min = 0
      min = Math.abs((arr1[0] - arr2[0]) * 60 + (arr1[1] - arr2[1]))
      return min
    },
    // 打开详情
    openClassDetail(value) {
      this.$router.push({
        name: 'CoursePeriodDetail',
        query: {
          code: value.coursecode,
          classCode: value.classcode,
          coursePeriodCode: value.code
        }
      })
    },
    // 编辑班级
    openClassEdit(item) {
      this.$emit('editClass', item.code)
    },
    // 删除
    del(row) {
      this.$emit('delCourse', row)
    }
  }
}
</script>
<style lang="scss">
.calendar-popover {
  padding: 20px;
  box-sizing: border-box;
  .content {
    .title {
      font-size: 16px;
      font-weight: bold;
      color: #4d5560;
      margin-right: 10px;
    }
    .box {
      width: 48px;
      height: 23px;
      background: #ffffff;
      border-radius: 2px 2px 2px 2px;
      border: 1px solid #0b75fa;
      line-height: 23px;
      text-align: center;
      font-size: 12px;
      color: #0b75fa;
      height: 60px;
    }
    .text {
      font-size: 13px;
      color: #66717e;
      line-height: 25px;
    }
    .btn {
      span {
        width: 48px;
        height: 25px;
        background: #ffffff;
        border-radius: 2px 2px 2px 2px;
        border: 1px solid #e4e7ec;
        font-size: 12px;
        color: #66717e;
        text-align: center;
        line-height: 25px;
        cursor: pointer;
        margin-top: 20px;
      }
      span:hover {
        background: #0b75fa;
        color: #ffffff;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.calendar-day {
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #e4e7ec;
  padding: 20px;
  .title {
    color: #66717e;
    margin-bottom: 40px;
    line-height: 21px;
  }
  .line {
    height: 60px;
    border-bottom: 1px solid #e4e7ec;
    display: flex;
    .box {
      box-sizing: border-box;
      height: 60px;
      width: 150px;
      cursor: pointer;
      color: #7d8c9e;
      line-height: 60px;
      padding: 0 20px;
    }
    .box:hover {
      //   background: #0b75fa;
      color: #0b75fa;
    }
  }
  .line:nth-child(1) {
    border-top: 1px solid #e4e7ec;
  }
}
</style>

